/**
 * FETT-AUSZEICHNUNG IM HANDBUCH.
 *
 * GEMESSEN am 14.08.2026 auf der Doku-Seite: Die Schritt-Texte werden als reiner
 * Text ausgegeben (`{s.step}`), enthalten aber Markdown-Sternchen. Auf dem
 * Bildschirm stand daher woertlich:
 *
 *     Auf der Zulagenblatt-Karte stehen **alle** Zulagenarten, ...
 *
 * Betroffen sind 80 von 113 Schritten in 22 von 25 Kapiteln — 114 Sternchen-
 * Paare. Die Auszeichnung traegt Bedeutung: sie markiert Feldnamen, Knopf-
 * beschriftungen und das eine Wort, auf das es im Satz ankommt. Roh dargestellt
 * ist sie schlimmer als gar keine — sie zerhackt genau die Stellen, die man
 * zuerst liest.
 *
 * Nur `**fett**`, nichts weiter: Was die Texte brauchen, ist eine Hervorhebung,
 * kein Markdown-Parser. Rueckgabe sind React-Knoten, kein HTML-String — es wird
 * nie fremder Text als Markup ausgefuehrt.
 */
import type { ReactNode } from "react";
import { createElement, Fragment } from "react";

/** Zerlegt einen Text an `**…**` und gibt die Stuecke als Knoten zurueck.
 *  Ungerade Sternchen-Paare bleiben unveraendert stehen (lieber ein sichtbares
 *  Sternchen als ein verschluckter Satzteil). */
export function fettTeile(text: string): Array<{ fett: boolean; text: string }> {
  const teile: Array<{ fett: boolean; text: string }> = [];
  const re = /\*\*(.+?)\*\*/gs;
  let pos = 0;
  for (const m of text.matchAll(re)) {
    if (m.index! > pos) teile.push({ fett: false, text: text.slice(pos, m.index) });
    teile.push({ fett: true, text: m[1]! });
    pos = m.index! + m[0].length;
  }
  if (pos < text.length) teile.push({ fett: false, text: text.slice(pos) });
  return teile;
}

/** Fuer die Anzeige: dieselbe Zerlegung als React-Knoten. */
export function fettText(text: string): ReactNode {
  const teile = fettTeile(text);
  return createElement(
    Fragment,
    null,
    ...teile.map((t, i) =>
      t.fett ? createElement("strong", { key: i }, t.text) : createElement(Fragment, { key: i }, t.text),
    ),
  );
}
